import React from 'react';

import Groups2OutlinedIcon from '@mui/icons-material/Groups2Outlined';
import Checkbox from '@mui/material/Checkbox';

import {getGroupColor} from '../../../../Utilities/ColorUtility';

export const GroupLabel = ({group}) => {
    const color = getGroupColor(group.GroupId || group.GroupName || '');
    const bgColor = color.replace('rgb(', 'rgba(').replace(')', ', 0.15)');

    return (
        <span
            data-testid={`group-label-${group.GroupName || ''}`}
            className="inline-flex items-center gap-1 px-2 py-1 rounded-menu text-xs font-medium whitespace-nowrap"
            style={{color, backgroundColor: bgColor, border: `1px solid ${color}`}}
        >
            <Groups2OutlinedIcon style={{fontSize: 14, color}} />
            {group.GroupName}
        </span>
    );
};

export const GroupRow = ({group, checked, onToggle}) => {
    const color = getGroupColor(group.GroupId || group.GroupName || '');
    const bgColor = color.replace('rgb(', 'rgba(').replace(')', ', 0.15)');

    return (
        <div
            data-testid={`select-group-${group.GroupName || group.GroupId || ''}`}
            className="flex items-center gap-2 px-2 py-1.5 rounded-lg cursor-pointer hover:bg-windowsandmenus-hover"
            onClick={onToggle}
        >
            <Checkbox size="small" checked={checked} onChange={() => {}} style={{padding: 2}} />
            <div
                className="flex items-center justify-center rounded-full flex-shrink-0"
                style={{width: 28, height: 28, backgroundColor: bgColor}}
            >
                <Groups2OutlinedIcon style={{fontSize: 16, color}} />
            </div>
            <span className="text-sm text-main-normal truncate">{group.GroupName}</span>
        </div>
    );
};
